import { FC, useState } from "react";
import { Modal } from "react-bootstrap-v5";
import { KTSVG } from "../../../helpers/KTSVG";
import { Form, Formik } from 'formik'
import * as Yup from 'yup'
import { showErrorAlert } from "../../../helpers/alert";
import { Elements } from "@stripe/react-stripe-js";
import { FormCardStripe } from "./FormCardStripe";
import type { FormCardStripeRef } from "./FormCardStripe";
import { loadStripe } from "@stripe/stripe-js";
import { useRef } from "react"
import { createPaymentMethod } from "../../../services/financialService";

interface Props {
    show: boolean,
    onClose: () => void,
    onSubmit: (data: any) => void,
    data?: any
}

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY || '', {locale: 'en'})

export const PaymentMethodModel: FC<Props> = ({ show, data, onClose, onSubmit }) => {
    const cardRef = useRef<FormCardStripeRef>(null)

    const initialForm = {
        card_name: '',
        payment_method: '',
    }

    const validateSchema = Yup.object({
        card_name: Yup.string().required('This field is required').max(60, "Max 60 characters"),
    })

    const handleOnSubmit = async (values) => {
        /* showErrorAlert({title:'',message:'coming soon.'});
        return; */
        const paymentMethod = await cardRef.current?.createPaymentMethod()
        if (paymentMethod == null || paymentMethod == undefined || paymentMethod == '') {
            return;
        }
        let created = await createPaymentMethod({ payment_method_id: paymentMethod, primary: false })
        if(created.success){
            showErrorAlert({title: 'Created', message: created.message })
            onSubmit(values)
            onClose()
        }
    }

    const stepFields = ['email','card_name']

    return (<Modal show={show} centered size="lg" backdrop="static" dialogClassName="team-admin-add-member-modal">
        <div className="modal-payment-method-payout">
            <div className="w-100 d-flex flex-row justify-content-between">
                <h1 className="modal-payment-method-payout__title">Add payment method</h1>
                <div className="rm-style-3 cursor-pointer" onClick={onClose}>
                    <KTSVG path="/media/svg/nobilis/closeX.svg" className="rm-style-4" />
                </div>
            </div>
            <Formik enableReinitialize initialValues={initialForm} validationSchema={validateSchema} onSubmit={handleOnSubmit}>
                {({ values, handleChange, isValid, validateForm, submitForm, isSubmitting }) => {
                    const haveErrors = async () => {
                        const fieldsToValidate = stepFields;
                        const errors = await validateForm();
                        const stepErrors = Object.keys(errors).filter((key) =>
                            fieldsToValidate.includes(key)
                        );
                        if(stepErrors.length>0){
                            showErrorAlert({title:'',message:`Please enter '${String(stepErrors[0]).replaceAll('_',' ')}' to save your progress.`});
                            return true;
                        }
                        return false;
                    }

                    const handleBeforeSubmit = async () => {
                        let error = await haveErrors();
                        if (!error) {
                            submitForm()
                        }
                    }

                    return (<Form className='profile-admin-form  profile-form-base' style={{ display: 'contents' }}>
                        
                        <Elements stripe={stripePromise}><FormCardStripe ref={cardRef} values={values} /></Elements>
                        {/* ACTIONS */}
                        <div className="modal-payment-method-payout__actions">
                            <div role='button' onClick={onClose} className={`tap-add-experience-2-btn-secondary`}>
                                Cancel
                            </div>
                            <button type="button" onClick={handleBeforeSubmit} className="tap-add-experience-2-btn-main" disabled={isSubmitting}>
                                {!isSubmitting ?  (<div className='tap-host-button-text tap-flex-center'>
                                    Add method
                                    &nbsp;<KTSVG path='/media/svg/nobilis/teams_and_partner/waitlist_nb_btn_icon_host_experience_btn.svg' />
                                </div>):(
                                    <span className='indicator-progress nb-heading-md'>
                                        Please wait...
                                        <span
                                            className='spinner-border spinner-border-sm align-middle ms-2'
                                            role='status'
                                            aria-hidden='true'
                                        />
                                    </span>
                                )}

                            </button>
                        </div>
                    </Form>)
                }}
            </Formik>
        </div>
    </Modal>);
}